// ============================================================================
// ZENOVA RENEWABLES - CENTRAL CONTENT FILE
// Edit any text, images, or details here to update across the entire website.
// ============================================================================

export const company = {
  name: "Zenova Renewables",
  tagline: "Smart Energy for Every Home",
  logoText: "ZENOVA",
  logoSubText: "RENEWABLES",
  phone: "+91 99900 36806",
  email: "contact@zenovarenewables.com",
  whatsapp: "+91 99900 36806",
  address: "B-350, Sector 20, Noida, Uttar Pradesh 201301, India",
  established: "2019",
  installations: "5,000+",
  cities: "45+",
  capacity: "22 MW+",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Solutions", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Solar Calculator", href: "#calculator" },
  { label: "Projects", href: "#projects" },
];

export const heroSlides = [
  {
    eyebrow: "Smart Energy for Every Home, Business & Industry",
    eyebrowNote: "Residential • C&I • Utility-Scale",
    title: "Powering India's Clean Energy Transition",
    titleAccent: "From Rooftops To Grid-Scale.",
    description:
      "From residential rooftops to multi-megawatt C&I plants, EV charging, battery swapping and energy storage — Zenova delivers end-to-end clean energy solutions backed by CAPEX, OPEX & Open Access models.",
    image:
      "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=1600",
    cta: "Talk To Our Experts",
  },
  {
    eyebrow: "Commercial & Industrial Solar",
    eyebrowNote: "CAPEX • OPEX • Open Access",
    title: "Cut Your Industrial Power Costs",
    titleAccent: "With Custom Solar Projects.",
    description:
      "Tailored on-grid, off-grid & hybrid systems for factories, hospitals, schools, telecom and data centres — with zero upfront investment options.",
    image:
      "https://images.pexels.com/photos/9875411/pexels-photo-9875411.jpeg?auto=compress&cs=tinysrgb&w=1600",
    cta: "Get C&I Proposal",
  },
  {
    eyebrow: "EV Charging & Battery Swapping",
    eyebrowNote: "Build the Mobility of Tomorrow",
    title: "Smart EV Infrastructure",
    titleAccent: "For Homes, Fleets & Public Spaces.",
    description:
      "Deploy AC/DC chargers, battery swapping centres and micro-grids that keep India's EV ecosystem moving 24x7.",
    image:
      "https://images.pexels.com/photos/12243093/pexels-photo-12243093.jpeg?auto=compress&cs=tinysrgb&w=1600",
    cta: "Partner With Us",
  },
];

export const trustBadges = [
  { value: "5,000+", label: "Projects Delivered" },
  { value: "100 MW+", label: "Solar Capacity" },
  { value: "45+", label: "Cities & States" },
  { value: "17", label: "Energy Solutions" },
];

export const aboutSection = {
  eyebrow: "Who We Are",
  title: "Pioneering",
  titleAccent: "Clean Energy Solutions",
  paragraphs: [
    "Zenova Renewables is a versatile clean-energy partner operating at the intersection of innovation and scale. Our expertise spans utility-scale, Commercial & Industrial (C&I), and customized residential solar — alongside EV charging, battery swapping, energy storage and green hydrogen.",
    "We offer flexible financial models including CAPEX, OPEX, EMI and Open Access so businesses and homeowners can adopt clean energy without compromise. As a National Approved Vendor for PM Surya Ghar Muft Bijli Yojana, we also help eligible households unlock central subsidies of up to \u20b978,000.",
  ],
  highlights: [
    "In-house team for design, execution & service",
    "CAPEX, OPEX, EMI & Open Access financing models",
    "Government policies & liaisoning handled end-to-end",
    "Tier-1 components with industry-leading warranties",
  ],
  image:
    "https://images.pexels.com/photos/6961122/pexels-photo-6961122.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const services = [
  {
    icon: "Factory",
    title: "C&I Solar Projects",
    description:
      "Customized solar solutions for commercial & industrial facilities to cut energy costs and meet sustainability goals.",
    image:
      "https://images.pexels.com/photos/9875411/pexels-photo-9875411.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "HandCoins",
    title: "OPEX Solar Projects",
    description:
      "Zero upfront investment — pay only for the energy you consume. We install, own and maintain the plant.",
    image:
      "https://images.pexels.com/photos/17890099/pexels-photo-17890099.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Home",
    title: "Residential Solar Projects",
    description:
      "Smart rooftop solar for homes with PM Surya Ghar subsidy support — start saving from day one.",
    image:
      "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Wrench",
    title: "Operation & Maintenance (O&M)",
    description:
      "AMC, remote monitoring, preventive checks and timely support to keep every plant at peak performance.",
    image:
      "https://images.pexels.com/photos/12224996/pexels-photo-12224996.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Warehouse",
    title: "Industrial Shed Re-roofing",
    description:
      "We upgrade industrial sheds to safely support solar arrays — better load handling, durability and yield.",
    image:
      "https://images.unsplash.com/photo-1655300256335-beef51a914fe?auto=format&fit=crop&w=800",
  },
  {
    icon: "PackageOpen",
    title: "Solar Products",
    description:
      "Tier-1 panels, inverters, mounting structures, cables and balance-of-system supplied across India.",
    image:
      "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?auto=format&fit=crop&w=800",
  },
  {
    icon: "Network",
    title: "Open Access",
    description:
      "Procure green power directly from utility-scale plants — cut tariffs and meet RE100 targets.",
    image:
      "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Sun",
    title: "Solar Farm (Utility-Scale)",
    description:
      "We develop and manage MW-scale ground-mount solar farms that feed the grid reliably.",
    image:
      "https://images.pexels.com/photos/9875411/pexels-photo-9875411.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Cpu",
    title: "Micro Grid",
    description:
      "Localized hybrid microgrids that work alongside or independent of the main grid for 24x7 power.",
    image:
      "https://images.pexels.com/photos/17890099/pexels-photo-17890099.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Blend",
    title: "Hybrid Solutions",
    description:
      "Solar + storage + DG/grid integration for maximum uptime and lowest LCOE.",
    image:
      "https://images.pexels.com/photos/12243093/pexels-photo-12243093.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "BatteryFull",
    title: "Utility-Scale ESS",
    description:
      "Ground-mounted battery energy storage systems for grid stability, peak shaving and time-shift.",
    image:
      "https://images.pexels.com/photos/12224996/pexels-photo-12224996.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "BatteryMedium",
    title: "Domestic ESS",
    description:
      "Home battery backup solutions — store your solar by day, run your home by night.",
    image:
      "https://images.unsplash.com/photo-1655300256335-beef51a914fe?auto=format&fit=crop&w=800",
  },
  {
    icon: "Replace",
    title: "Battery Swapping Centre",
    description:
      "Turnkey 2W/3W battery swapping stations enabling instant power for the EV ecosystem.",
    image:
      "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Plug",
    title: "EV Charging Infrastructure",
    description:
      "AC & DC chargers for homes, fleets, malls and highways — installation, OCPP & operations.",
    image:
      "https://images.pexels.com/photos/9875411/pexels-photo-9875411.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Leaf",
    title: "Carbon Trading",
    description:
      "Measure, manage and monetize carbon credits — support your ESG goals while reducing footprint.",
    image:
      "https://images.pexels.com/photos/17890099/pexels-photo-17890099.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "FlaskConical",
    title: "Green Hydrogen",
    description:
      "Renewable-powered electrolysis solutions enabling industries to decarbonize at scale.",
    image:
      "https://images.pexels.com/photos/12243093/pexels-photo-12243093.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    icon: "Droplets",
    title: "Solar Pumping Solutions",
    description:
      "Efficient solar water pumping for agriculture, residential and industrial use — diesel-free.",
    image:
      "https://images.pexels.com/photos/12224996/pexels-photo-12224996.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
];

export const industries = [
  { icon: "Hospital", name: "Hospitals" },
  { icon: "School", name: "Schools" },
  { icon: "GraduationCap", name: "Colleges & Universities" },
  { icon: "Factory", name: "Manufacturing Plants" },
  { icon: "Pill", name: "Pharmaceutical" },
  { icon: "Wheat", name: "Agriculture" },
  { icon: "Beef", name: "Dairy & Cold Storage" },
  { icon: "Cookie", name: "Food & Beverage" },
  { icon: "HardHat", name: "Cement & Steel" },
  { icon: "Car", name: "Automobile" },
  { icon: "Hammer", name: "Handicraft & MSME" },
  { icon: "Antenna", name: "Telecom" },
  { icon: "Server", name: "Data Centres" },
  { icon: "ShieldHalf", name: "Defence" },
  { icon: "Train", name: "Railway" },
  { icon: "Building2", name: "Government Projects" },
  { icon: "Home", name: "Residential" },
  { icon: "Plug", name: "EV Charging" },
];

export const whyChooseUs = [
  {
    icon: "BadgePercent",
    title: "Subsidy Assistance",
    text: "Full support for PM Surya Ghar subsidy claims up to \u20b978,000.",
  },
  {
    icon: "Wallet",
    title: "Flexible Financing Options",
    text: "EMIs starting from \u20b91,499/month with leading bank partners.",
  },
  {
    icon: "FileCheck2",
    title: "End-to-End Documentation",
    text: "DISCOM applications, net-metering & approvals fully handled.",
  },
  {
    icon: "Compass",
    title: "Custom Design Survey",
    text: "Free on-site survey with shadow analysis and yield estimation.",
  },
  {
    icon: "Headset",
    title: "Dedicated Support",
    text: "A single project manager from day one to commissioning.",
  },
  {
    icon: "Settings",
    title: "Annual Maintenance",
    text: "Bundled AMC with remote monitoring and cleaning cycles.",
  },
];

export const processSteps = [
  { step: "01", title: "Enquiry & Consultation", text: "Share your bill, we estimate savings & recommend system size." },
  { step: "02", title: "Free Site Survey", text: "Our engineer visits to inspect roof, shadow & feasibility." },
  { step: "03", title: "Custom Design & Quote", text: "You receive a detailed proposal with yield projections." },
  { step: "04", title: "Documentation & Subsidy", text: "We file DISCOM forms and apply for PM Surya Ghar subsidy." },
  { step: "05", title: "Installation", text: "Certified team installs in 3\u20137 days with safety standards." },
  { step: "06", title: "Commissioning & Handover", text: "Net-meter installed, system goes live, you start saving." },
];

export const projects = [
  {
    name: "Mr. Arvind Kumar Chaurasia",
    location: "Lucknow, UP",
    capacity: "5 kW",
    image:
      "https://images.pexels.com/photos/12243093/pexels-photo-12243093.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Mrs. Beba Devi",
    location: "Patna, Bihar",
    capacity: "3 kW",
    image:
      "https://images.pexels.com/photos/17890099/pexels-photo-17890099.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Mr. Rita Kushwaha",
    location: "Kanpur, UP",
    capacity: "4 kW",
    image:
      "https://images.pexels.com/photos/12224996/pexels-photo-12224996.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Mr. Rama Singh",
    location: "Varanasi, UP",
    capacity: "6 kW",
    image:
      "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?auto=format&fit=crop&w=800",
  },
];

export const testimonials = [
  {
    name: "Ramesh Verma",
    location: "Agra, Uttar Pradesh",
    rating: 4,
    text: "I enrolled for a Rooftop Solar System and within just 10 days Zenova installed my 5kW plant. My bill dropped from \u20b96,500 to under \u20b9700.",
    image:
      "https://images.pexels.com/photos/3030223/pexels-photo-3030223.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
  {
    name: "Sunita Sharma",
    location: "Mathura, Uttar Pradesh",
    rating: 5,
    text: "The team handled every single paperwork including subsidy. I received \u20b978,000 in my account within 45 days as promised. Truly hassle-free.",
    image:
      "https://images.pexels.com/photos/13040216/pexels-photo-13040216.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
  {
    name: "Asha Yadav",
    location: "Noida, Uttar Pradesh",
    rating: 5,
    text: "The engineers were polite, on-time and explained everything. Best decision for our family \u2014 we now generate more units than we use.",
    image:
      "https://images.pexels.com/photos/5194107/pexels-photo-5194107.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
];

export const indianStates = [
  "Andhra Pradesh",
  "Bihar",
  "Chhattisgarh",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Tamil Nadu",
  "Telangana",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

export const billRanges = [
  "Below \u20b91,500",
  "\u20b91,500 \u2013 \u20b93,000",
  "\u20b93,000 \u2013 \u20b95,000",
  "\u20b95,000 \u2013 \u20b910,000",
  "\u20b910,000 \u2013 \u20b920,000",
  "Above \u20b920,000",
];

export const faqs = [
  {
    q: "What services does Zenova Renewables provide?",
    a: "Zenova offers end-to-end clean energy solutions including C&I solar, residential rooftop, OPEX/CAPEX models, Open Access, ESS, EV charging, battery swapping, micro-grids, solar pumping, green hydrogen and O&M services across India.",
  },
  {
    q: "What financial models do you offer?",
    a: "We support CAPEX (upfront purchase), OPEX (pay-per-unit with zero investment), EMI financing through bank partners, and Open Access for large industrial consumers.",
  },
  {
    q: "How much subsidy can I get under PM Surya Ghar?",
    a: "Households can get up to \u20b978,000 in central subsidy for systems up to 3kW, with additional state benefits in some regions. Zenova handles the full documentation.",
  },
  {
    q: "Do you serve commercial and industrial clients?",
    a: "Yes. We design and execute custom C&I solar plants from 50kW to multi-MW, including rooftop, ground-mount, carport and floating solar, along with energy audits and load-profile optimization.",
  },
  {
    q: "What about EV charging and battery swapping?",
    a: "We deliver turnkey EV charging infrastructure (AC/DC) for homes, fleets and public spaces, plus battery swapping centres for 2W/3W mobility operators.",
  },
  {
    q: "How long does installation take?",
    a: "A typical 3\u20136 kW residential system takes 3\u20137 working days after approval. C&I projects range from 4\u201316 weeks based on size and site complexity.",
  },
  {
    q: "What warranties do you offer?",
    a: "Tier-1 panels carry 10-year product and 25-year linear performance warranties. Inverters come with 5\u201310 year warranties. Our workmanship warranty is 5 years.",
  },
  {
    q: "Do you provide O&M after installation?",
    a: "Yes \u2014 we offer Annual Maintenance Contracts with remote monitoring, scheduled cleaning, preventive checks and 24x7 technical support.",
  },
];

export const footerLinks = {
  company: [
    { label: "About Us", href: "#about" },
    { label: "Our Projects", href: "#projects" },
    { label: "Services", href: "#services" },
    { label: "Careers", href: "#" },
  ],
  resources: [
    { label: "Solar Calculator", href: "/#calculator" },
    { label: "PM Surya Ghar", href: "/#services" },
    { label: "Blog", href: "/blog" },
    { label: "FAQs", href: "/#faq" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Refund Policy", href: "/refund" },
    { label: "Sitemap", href: "/#" },
  ],
};

export const socials = [
  { name: "Facebook", icon: "Facebook", href: "https://facebook.com/zenovarenewables" },
  { name: "Instagram", icon: "Instagram", href: "https://instagram.com/zenovarenewables" },
  { name: "YouTube", icon: "Youtube", href: "https://youtube.com/@zenovarenewables" },
  { name: "LinkedIn", icon: "Linkedin", href: "https://linkedin.com/company/zenovarenewables" },
];

// -----------------------------------------------------------------------------
// LEGAL PAGES
// Each page has: title, lastUpdated (display string), and a `content` string.
// The content uses very simple markdown-lite:
//   ## Section heading
//   Paragraph text on its own lines. Blank line separates paragraphs.
//   - Bullet points start with "- "
// -----------------------------------------------------------------------------
export const legalPages = {
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: July 2025",
    content: `Zenova Renewables ("we", "our", "us") is committed to protecting the privacy of every visitor and customer. This policy explains what data we collect and how we use it.

## Information We Collect
We collect information you provide directly to us, such as your name, phone number, email address, state, and monthly electricity bill range when you fill out an enquiry form. We may also collect basic usage data such as pages visited and device type.

## How We Use Your Information
- To respond to your enquiries and provide quotations
- To schedule site visits and installation services
- To assist with PM Surya Ghar and other subsidy applications
- To send service updates, invoices, and important notices
- To improve our website and services

## Sharing of Information
We do not sell your personal data. We may share information with:
- Our authorized installation and service partners for the sole purpose of fulfilling your project
- Government portals (e.g. National Portal for Rooftop Solar) as required for subsidy processing
- Payment processors and financial institutions when you opt for EMI financing

## Data Security
We use industry-standard measures to protect your data. Access to customer data is restricted to authorized team members only.

## Your Rights
You may request to review, update, or delete your personal information at any time by writing to us at the contact address on this website.

## Cookies
Our website uses essential cookies to keep the site working and analytics cookies to understand traffic patterns. You can disable cookies through your browser settings.

## Changes to This Policy
We may update this policy from time to time. The "Last updated" date above will reflect the most recent revision.

## Contact
For any privacy-related questions, please write to us using the contact details listed in our website footer.`,
  },
  terms: {
    title: "Terms of Service",
    lastUpdated: "Last updated: July 2025",
    content: `Welcome to Zenova Renewables. By accessing or using our website and services, you agree to the following terms.

## Use of Website
The content on this website is provided for informational purposes. You agree not to misuse the site, attempt to breach its security, or use it for any unlawful activity.

## Services and Quotations
- All quotations are subject to a site survey and technical feasibility check.
- Pricing shown or estimated on the website is indicative and may be revised in the final proposal.
- System performance figures such as yield and savings are estimates and depend on site conditions, weather, and consumption patterns.

## Orders and Payments
- Orders are confirmed only upon receipt of a signed proposal and applicable advance payment.
- Payment terms, milestones, and financing (CAPEX, OPEX, EMI, Open Access) are outlined in the individual customer agreement.
- Government subsidies are disbursed by the relevant authority and are not under our direct control.

## Warranties
- Panels, inverters, and structures carry the warranty of the respective original equipment manufacturer.
- We provide a workmanship warranty as detailed in the customer agreement.
- Warranties are void if the system is tampered with by unauthorized personnel.

## Intellectual Property
All logos, brand names, images, and content on this website are the property of Zenova Renewables or their respective owners. You may not reproduce them without written permission.

## Limitation of Liability
To the maximum extent permitted by applicable law, Zenova Renewables shall not be liable for indirect, incidental, or consequential damages arising from the use of our services or website.

## Governing Law
These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at Noida, Uttar Pradesh.

## Changes
We reserve the right to update these terms at any time. Continued use of the website constitutes acceptance of the updated terms.

## Contact
For any questions about these terms, please reach us using the contact details in the footer of this website.`,
  },
  refund: {
    title: "Refund Policy",
    lastUpdated: "Last updated: July 2025",
    content: `This refund policy explains how deposits, advances, and payments are handled for services purchased from Zenova Renewables.

## Booking Advance
- A booking advance secures your slot in our installation calendar and initiates material procurement.
- If you cancel within 7 days of paying the booking advance and before site survey, 90% of the amount is refundable.
- Beyond 7 days or after site survey, the refund is subject to actual costs already incurred.

## Post-Order Cancellation
Once material has been dispatched or installation has begun, order cancellation is not permitted. Any refund in exceptional cases will be net of material, logistics, and labour costs.

## Service Non-Delivery
If we are unable to complete the installation due to reasons attributable solely to us, 100% of the amounts paid will be refunded within 30 working days.

## Subsidy Refunds
Government subsidies are disbursed by DISCOMs and other authorities directly to the customer's bank account. Zenova Renewables is not responsible for delays or rejections at the authority level, but we will assist with follow-ups.

## Refund Method
All refunds are processed through the same payment method used for the original transaction. UPI and net-banking refunds usually reflect within 5-7 working days; card refunds may take up to 14 working days.

## How to Request a Refund
Please write to us at the email listed in the footer with your order reference number, reason for refund, and preferred contact number. Our team will respond within 2 working days.

## Contact
For any refund-related queries, please use the contact details in the footer of this website.`,
  },
};

// -----------------------------------------------------------------------------
// BLOG POSTS
// -----------------------------------------------------------------------------
export const blogPosts = [
  {
    id: "post-pm-surya-ghar-guide",
    slug: "pm-surya-ghar-yojana-complete-guide",
    title: "PM Surya Ghar Muft Bijli Yojana: A Complete Homeowner's Guide",
    excerpt:
      "Everything you need to know about India's flagship rooftop solar subsidy scheme — eligibility, subsidy amount, documents required, and how Zenova handles it end-to-end.",
    cover:
      "https://images.pexels.com/photos/9875422/pexels-photo-9875422.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Subsidies",
    author: "Zenova Team",
    publishedAt: "2025-06-18",
    content: `The PM Surya Ghar Muft Bijli Yojana is a landmark initiative by the Government of India to accelerate residential solar adoption. It aims to provide free electricity to one crore homes and drastically reduce power bills.

## Who Is Eligible?
- Indian residents owning their home with a functional roof
- Households with a valid electricity connection
- Systems up to 3 kW qualify for the maximum central subsidy

## Subsidy Slabs
- 1 kW system: up to Rs 30,000
- 2 kW system: up to Rs 60,000
- 3 kW system: up to Rs 78,000

## Documents Required
- Aadhaar of the applicant
- Recent electricity bill
- Property proof
- Passport size photograph
- Bank account details for subsidy transfer

## How Zenova Helps
- Free feasibility survey at your home
- Custom system design and detailed quotation
- Complete DISCOM application and net metering paperwork
- Installation by certified engineers within 7 working days
- Subsidy claim tracking end-to-end

Ready to explore? Get in touch through our contact form for a free consultation.`,
  },
  {
    id: "post-ci-vs-residential-solar",
    slug: "commercial-vs-residential-solar",
    title: "C&I vs Residential Solar: Which One Fits Your Setup?",
    excerpt:
      "A quick side-by-side comparison of Commercial & Industrial versus Residential solar — payback periods, financing options, and typical use cases for Indian businesses and homes.",
    cover:
      "https://images.pexels.com/photos/9875411/pexels-photo-9875411.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Solar Basics",
    author: "Zenova Team",
    publishedAt: "2025-06-05",
    content: `Whether you own a factory or a bungalow, solar can drastically cut your electricity costs. But the right approach differs.

## Residential Solar
- Typical system size: 1 kW to 10 kW
- Eligible for PM Surya Ghar subsidy up to Rs 78,000
- Simple on-grid net-metered setup for most homes
- Payback: 3 to 5 years

## Commercial & Industrial (C&I) Solar
- Typical system size: 50 kW to several MW
- CAPEX, OPEX, and Open Access financing options
- Larger footprint requires engineering optimization
- Payback: 3 to 6 years depending on tariff and utilization

## Which Financing Model?
- CAPEX suits businesses with capital and a long-term view
- OPEX suits enterprises that prefer per-unit pricing with zero upfront cost
- Open Access is ideal for very high consumption loads with grid access

## Talk to an Expert
Every site is unique. Reach out for a tailored assessment.`,
  },
  {
    id: "post-battery-storage-explained",
    slug: "home-battery-storage-explained",
    title: "Home Battery Storage: Do You Really Need One?",
    excerpt:
      "Domestic energy storage (ESS) is booming — but is it right for your home? Here's a practical guide to help you decide.",
    cover:
      "https://images.pexels.com/photos/12224996/pexels-photo-12224996.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Energy Storage",
    author: "Zenova Team",
    publishedAt: "2025-05-22",
    content: `Domestic energy storage lets you use your solar power at night and during outages. But it also adds cost.

## When It Makes Sense
- Frequent or long power cuts in your area
- High evening consumption when solar is not producing
- Areas with time-of-day electricity pricing
- Homes with critical loads such as medical equipment or work-from-home setups

## When It May Not Be Worth It
- Areas with reliable grid power and good net-metering
- Small daily consumption where the ROI on batteries is long

## What to Look For
- Battery chemistry: LFP is the preferred choice for safety and cycle life
- Warranty: at least 10 years or 6,000 cycles
- Inverter compatibility with your existing solar system

Book a free consultation to model your specific case.`,
  },
];
